<template>
  <router-view></router-view>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'App',
});
</script>

<style>
/* 全局样式统一引入(顺序:变量 -> 字体 -> 主题 -> 特效 -> 全局) */
@import './assets/styles/variables.css';
@import './assets/styles/fonts.css';
@import './assets/styles/theme.css';
@import './assets/styles/effects.css';
@import './assets/styles/global.css';
</style>
